import { Component } from '@angular/core';

@Component({
  selector: 'app-cart-add-server-error-alert',
  templateUrl: './cart-add-server-error-alert.component.html',
  styleUrls: ['./cart-add-server-error-alert.component.scss']
})
export class CartAddServerErrorAlertComponent {
  reloadPage() {
    window.location.reload();
  }
}
